module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.pedidos), function(pedido) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(pedido.numero))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatearFecha")(pedido.fechaEntrega)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("platosSerialized")(pedido)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(pedido.estado))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatearMoneda")(pedido.montoTotal)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatearMoneda")(pedido.precio.precio)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(pedido.montoTotal / pedido.precio.precio))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("multiplicadorCalculado")(pedido)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatearMoneda")(_vm._f("montoPedido")(pedido))))]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "input-group"
    }, [_c('input', {
      ref: ("input-" + (pedido._id)),
      refInFor: true,
      staticClass: "form-control input-sm",
      attrs: {
        "type": "text"
      }
    }), _vm._v(" "), _c('button', {
      staticClass: "btn btn-fill btn-sm",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.cambiar(pedido._id, ("input-" + (pedido._id)))
        }
      }
    }, [_vm._v("Cambiar")])])])])
  }))])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Nro")]), _vm._v(" "), _c('th', [_vm._v("Fecha")]), _vm._v(" "), _c('th', [_vm._v("Detalle")]), _vm._v(" "), _c('th', [_vm._v("Estado")]), _vm._v(" "), _c('th', [_vm._v("Monto")]), _vm._v(" "), _c('th', [_vm._v("Precio combo")]), _vm._v(" "), _c('th', [_vm._v("Detectado")]), _vm._v(" "), _c('th', [_vm._v("Calculado")]), _vm._v(" "), _c('th', [_vm._v("Calculado")]), _vm._v(" "), _c('th')])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-42c3cc1c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pedido/ReparadorPedidos.vue
// module id = 1124
// module chunks = 5